const MENU_TYPES = {
    EXTENSIONS: "extensions",
    EXTENSION_MAPPING: "extension-mapping",
    WEBHOOKS: "webhooks",
    CDR: "cdr",
    AUTOMATIONS: "automations",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.EXTENSIONS,
        label: "Dahililer",
        icon: {
            type: "material-icons",
            name: "phone",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.EXTENSION_MAPPING,
        label: "Dahili Eşleştirme",
        icon: {
            type: "material-icons",
            name: "link",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.WEBHOOKS,
        label: "Webhooklar",
        icon: {
            type: "material-icons",
            name: "webhook",
        },
        group: "Ana Ayarlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.CDR,
        label: "Arama Kayıtları (CDR)",
        icon: {
            type: "material-icons",
            name: "call",
        },
        group: "Raporlar",
    },
    {
        enabled: true,
        key: MENU_TYPES.AUTOMATIONS,
        label: "Otomasyonlar",
        icon: {
            type: "component",
            name: "AutomationIcon",
            class: "myIcon",
            style: { fill: "var(--color-icon-primary-default)" },
        },
        group: "Ana Ayarlar",
    },
];

export default {
    MENU_TYPES,
    Items,
};
